import React from "react";
import PicListContainer from "../containers/PicListContainer";

const App = () => {
  return (
    <div>
      <PicListContainer />
    </div>
  );
};

export default App;
